
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const PieChartSa = ({ abonos }) => {

    const pagados = abonos.filter(a => a.ahorro_pagado == true).length
    const no_pagados = abonos.filter(a => a.ahorro_pagado == false).length

    const data = [
        { name: 'PAGADOS', value: pagados },
        { name: 'PENDIENTES', value: no_pagados },
    ];

    // Colores personalizados
    const COLORS = ['#00c462', '#c40000'];
    // ✅ Leyenda personalizada (abajo del gráfico)
    const renderCustomLegend = (props) => {
        const { payload } = props;
        return (
            <ul className="list-unstyled text-center">
                {payload.map((entry, index) => (
                    <li key={`item-${index}`} style={{ color: entry.color }}>
                        <strong>{entry.payload.name}</strong>: {entry.payload.value}
                    </li>
                ))}
            </ul>
        );
    };

    return (
        <>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8">
                        <h4 className="text-center mb-4">Abonos</h4>
                        <div style={{ width: '100%', height: 300 }}>
                            <ResponsiveContainer>
                                <PieChart>
                                    <Pie
                                        data={data}
                                        dataKey="value"
                                        nameKey="name"
                                        cx="50%"
                                        cy="50%"
                                        outerRadius="80%"
                                        labelLine={true}
                                        label={({ name, value, percent }) => `(${(percent * 100).toFixed(0)}%)`}
                                    >
                                        {data.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                        ))}
                                    </Pie>
                                    <Tooltip />
                                    <Legend content={renderCustomLegend} />
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}


export default PieChartSa